module.exports = __webpack_public_path__ + "img/8975feb5d09a4952b1e96af73e9aef4e-1024.04ccf7d8.jpg";